module.exports = __webpack_public_path__ + "static/media/pexels-stories.91a0fba3.jpg";